export default "__VITE_ASSET__DbrFaWN$__"